module.exports = __webpack_public_path__ + "static/img/moment.fac8989.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/moment.png
// module id = 3iWI
// module chunks = 1